import { render, staticRenderFns } from "./credit-note-clearance-table.vue?vue&type=template&id=1c1bbb46&scoped=true&"
import script from "./credit-note-clearance-table.vue?vue&type=script&lang=ts&"
export * from "./credit-note-clearance-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1bbb46",
  null
  
)

export default component.exports